import { observable } from "mobx";
import { api_adm } from "../../api";
import { toast } from "react-toastify";

export class _MonitoraTopicStore {

  obs = observable({
    consumers: [],
    lastUpdated: null as number | null,
    topics: []
  })

  async handleMonitorar(topic: string) {

    try {

      let resp = await api_adm.post(`/api/admin/monitorar/consumer`, { topic });

      this.obs.consumers = null;

      if (resp.status == 200 && resp.data.length > 0) {

        this.obs.consumers = resp.data

      }

      this.obs.lastUpdated = Date.now();

    } catch (ex) {

    }

  }

  async handleTopics() {

    try {

      let resp = await api_adm.get(`/api/admin/topics`);

      this.obs.topics = [];

      if (resp.status == 200 && resp.data.length > 0) {

        this.obs.topics = resp.data

      }

      this.obs.lastUpdated = Date.now();

    } catch (ex) {

    }

  }

  async handleCreateTopic(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/topic/create', params)

      if (resp.data.ok == true) {

        toast.success('Tópico criado com sucesso.', {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

  async handleUpdateTopic(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/topic/update', params)

      if (resp.data.ok == true) {

        toast.success('Tópico atualizado com sucesso.', {});

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleDeleteTopic(id: string) {

    try {

      let resp = await api_adm.delete(`/api/admin/topic/${id}`)

      if (resp.data.ok == true) {

        toast.success('Tópico deletado com sucesso.', {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

}

export const MonitoraTopicStore = new _MonitoraTopicStore();
